import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index/index.vue'
import appConfig from '@/config/app.config.js'
import wxConfig from '@/config/wx.config.js'
import {
  Dialog
} from 'vant';



// 全局注册
Vue.use(Dialog);
Vue.use(VueRouter)

const routes = [
  {
    path: '/', // shouye
    name: 'Index',
    component: Index
  },
  {
    path: '/regist',//zhuce
    name: 'Regist',
    component: () => import(/* webpackChunkName: "about" */ '../views/Regist/index.vue')
  },
  {
    path: '/game',//dati
    name: 'Game',
    component: () => import(/* webpackChunkName: "about" */ '../views/Game/index.vue')
  },
  {
    path: '/rank',//paihang
    name: 'Rank',
    component: () => import(/* webpackChunkName: "about" */ '../views/Rank/index.vue')
  },
  {
    path: '/result',//paihang
    name: 'Result',
    component: () => import(/* webpackChunkName: "about" */ '../views/Result/index.vue')
  },
  {
    path: '/glory',//rongyu
    name: 'Glory',
    component: () => import(/* webpackChunkName: "about" */ '../views/Glory/index.vue')
  },
  {
    path: '/certificate',//rongyu
    name: 'Certificate',
    component: () => import(/* webpackChunkName: "about" */ '../views/Certificate/index.vue')
  },
  {
    path: '/rank',//rongyu
    name: 'Rank',
    component: () => import(/* webpackChunkName: "about" */ '../views/Rank/index.vue')
  },
  {
    path: '/regist1',//zhuce
    name: 'Regist1',
    component: () => import(/* webpackChunkName: "about" */ '../views/Registback/index.vue')
  },

]
// 避免反复进入同一路由报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}




const router = new VueRouter({
  routes
})
window.appConfig = appConfig;

router.beforeEach((to, from, next) => {
  if (!window.agenet) {
    window.agenet = appConfig.checkUserAgent()
  }

wxConfig.ShareLocal("大手拉小手 万个家庭学党史","大手拉小手 万个家庭学党史","","https://activity.sznews.com/front/lhedu2021_front/#/",)


  // if (!env) {
  appConfig.setupEnv()
  // }
  let env = localStorage.getItem('env');
  //   if (to.name != 'home'&& to.name != 'list') { // 前往首页或列表以外的路由


  if (to.name != "Index" && from.name == null) {  // 输入的路由不是首页 自动跳转到首页
    next('/')
    return
  }
  if (to.name == "Result" && from.name != "Game") {  // 结果页面只能从game页跳转 否则跳回首页
    next('/')
    return
  }

  if (env != 'app') { // 非app环境  
    if (process.env.NODE_ENV === 'development') {
      localStorage.setItem('luoohutoken', `{
        "sign" : "b21501bf5260fd2e6d2a1a4ddf0ad702",
        "data" : "7pXRTmW1rOlFKQhXUtULuMNmmEJjtVcUSc5IpEqnxhttnw8YREF25NL_3Xs3S4YbjIu91bt-OObSSKwHYwfisXJJi2G9PXf7I4vvR7uYxhEfgo77IKeYgG4_Dr212PyvgU5G-kcqoqpwx3mFd_98_AOyS2Kk0nDa83Ujfx1czJwU7FNLrDwWHfax06-AVE3wQ8YfE54o3c-mnGbmdOxa3rQnm4Tl5i2vAO_nYB6QveiqWTf5OPFTNpNzLkw2zxgocN6i3wTeZLbsq-F6xnuOfujIrb-tqqNRkxwJ2LdQ5MY_HmvZ2k1IfxMEM2ySZa8Imbf2JKsMWcoeKvEdKbVCUg==",
        "appid" : "0af2398bebd1c86cfb868f50e0d06f73",
        "timestamp" : "1624617533",
        "nonceStr" : "naAJsDlGMDmqT02M5zCA0aWQjKLaqCcS"
      }`)
      next()
      return
    } else {
      if (to.name != 'Index') {

        Dialog.confirm({
          message: '请下载罗湖Plus参与答题',
          theme: 'round-button',
          confirmButtonColor: '#E93F4C',
          confirmButtonText: '打开APP',
        }).then(() => {
          window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.luohunews';
        }).catch(() => {

          next('/')
          return
        });
      }
      else {
        next()
      }
    }



  } else { // app环境

    appConfig.checkLogin();
    // 
    // var oldtoken = localStorage.getItem('luoohutoken');
    // var checktoken = setInterval(() => {
    //   if (oldtoken != localStorage.getItem('luoohutoken')) {
    //     clearInterval(checktoken)
    //   }
    // }, 10)
    next()
    //         }
    //       }, 10);

  }

  //   } else {


  //       next()


  //   }

})



export default router
